import { render, staticRenderFns } from "./StudentScholarshipList.vue?vue&type=template&id=4474fd06"
import script from "./StudentScholarshipList.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipList.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipList.vue?vue&type=style&index=0&id=4474fd06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports